import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import logoImage from '../images/Logo-Base-basic.png';
import '../components/Login/login.css';

const VerifyEmail = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const email = location.state?.email || 'your email';

    const handleClose = () => {
        const from = location.state?.from || '/';
        navigate(from);
        // Reload to update NavBar state
        window.location.reload();
    };

    return (
        <div className="login-page-container">
            <div className="login-page-wrapper">
                <div className="login-page-content">
                    {/* Left side - Image (desktop only) */}
                    <div className="login-page-image" />
                    
                    {/* Right side - Content */}
                    <div className="login-page-form-container">
                        {/* Close button - top right of form */}
                        <button 
                            type="button"
                            className="login-page-close-button"
                            onClick={handleClose}
                            aria-label="Close"
                        >
                            <CloseIcon />
                        </button>
                        
                        <div className="login-page-form">
                            <div className="verify-email-content">
                                <div className="verify-email-icon">
                                    <img src={logoImage} alt='logo' />
                                </div>
                                <h2 className="login-page-title">Please verify your email</h2>
                                <div className="verify-email-text">
                                    <p>
                                        A link to verify your account has been sent to <strong>{email}</strong>.
                                    </p>
                                    <p>
                                        Please check your email inbox and spam folder for a link from MyCustomFrame.
                                    </p>
                                </div>
                                <div className="login-page-actions">
                                    <button 
                                        type="button" 
                                        className="btn button-dark btn-lg w-100" 
                                        onClick={handleClose}
                                    >
                                        Got it
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VerifyEmail;

